import React, { memo } from 'react'
import PropTypes from 'prop-types'

import Loader from '../../Loaders/Loader'
import PreviewThumbnail from './PreviewThumbnail'

import useStyles from './styles'

const FilePreview = memo(function WrappedFilePreview({
  isLoading,
  filePreviewType,
  fileUrl,
  fileName,
  fileDescription,
  FileIcon,
  iconColor,
  fileFormat
}) {
  const classes = useStyles({ iconColor, hasIcon: !!FileIcon })

  return (
    <>
      {isLoading ? (
        <Loader className={classes.preview} />
      ) : (
        <PreviewThumbnail
          fileUrl={fileUrl}
          filePreviewType={filePreviewType}
          FileIcon={FileIcon}
          iconColor={iconColor}
          fileFormat={fileFormat}
        />
      )}
      <div className={classes.details}>
        <div className={classes.fileName}>{fileName}</div>
        {fileDescription && <p className={classes.description}>{fileDescription}</p>}
      </div>
    </>
  )
})

FilePreview.propTypes = {
  isLoading: PropTypes.bool,
  filePreviewType: PropTypes.string,
  fileUrl: PropTypes.string,
  fileName: PropTypes.string,
  fileDescription: PropTypes.string,
  FileIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  iconColor: PropTypes.string,
  fileFormat: PropTypes.string
}

export default FilePreview
